import { render, staticRenderFns } from "./Plataforma.vue?vue&type=template&id=2156fc72&"
import script from "./Plataforma.vue?vue&type=script&lang=js&"
export * from "./Plataforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports